import { AssetActionInterface } from "../../../models/AssetModel/AssetAction/AssetAction";
import client from "../../client";

class AssetActionService {
  async GetAll(assetId: string, page: number, pageSize: number) {
    try {
      let url = `/api/AssetActions/getbyAssetId/${assetId}`;
      const { data } = await client.post<AssetActionInterface[]>(url, {
        page,
        pageSize,
      });
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/AssetActions/getbyid/${id}`;

      const { data } = await client.get<AssetActionInterface>(url);

      return data;
    } catch (error) {
      throw error;
    }
  }

  async Save(customer: AssetActionInterface) {
    try {
      let url = `/api/AssetActions`;

      const { data } = await client.post<AssetActionInterface>(url, customer);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, customer: AssetActionInterface) {
    try {
      let url = `/api/AssetActions/update/${id}`;

      const { data } = await client.post<AssetActionInterface>(url, customer);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/AssetActions/remove/${id}`;
      await client.post<AssetActionInterface>(url, { url: "" });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new AssetActionService();
